import { AdminManagerTab } from './AdminManagerTab';
import { useContext } from 'react';
import { GlobalContext } from 'GlobalContext';
import { isAdmin, isSale, isPhoneSize } from 'utils/util';
import { KPI } from './pages/KPI';
export function Admin() {
    const { recordManagerAdminTab } = useContext(GlobalContext);
    // const [tabSelection, setTabSelection] = useState("Investors")

    const content = (
        <div
            style={
                isPhoneSize()
                    ? {
                          height: 'calc(100vh - 230px)',
                      }
                    : {
                          height: '100vh',
                      }
            }
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    // overflowX: "scroll",
                    overflowY: 'scroll',
                    scrollbarWidth: 'none',
                    width: '100px',
                }}
            >
                <AdminManagerTab text={'KPI'} />
            </div>
            <div
                style={
                    isPhoneSize()
                        ? {
                              height: 'calc(100vh - 310px)',
                              overflowY: 'scroll',
                              scrollbarWidth: 'none',
                              overflowX: 'hidden',
                          }
                        : {
                              height: 'calc(100vh - 50px)',
                              overflowY: 'scroll',
                              scrollbarWidth: 'none',
                              overflowX: 'hidden',
                          }
                }
            >
                <div style={{}}>
                    {recordManagerAdminTab === 'KPI' && <KPI />}
                </div>
            </div>
            {/* 
            
             */}
        </div>
    );

    return (
        <>
            {!isAdmin() && !isSale() && <>Not authorized</>}
            {(isAdmin() || isSale()) && content}
        </>
    );
}
